// src/MainMenu.js
export default function MainMenu({ onNav, onChangeSite }) {
  const items = [
    {
      key: "ezlookup",
      title: "EZ Lookup",
      desc: "Quick part lookup by number",
      icon: "⚡",
      accent: "linear-gradient(135deg,#2563eb,#06b6d4)",
    },
    {
      key: "search",
      title: "Search Parts",
      desc: "Filter by description, location, category",
      icon: "🔎",
      accent: "linear-gradient(135deg,#7c3aed,#ec4899)",
    },
    {
      key: "allparts",
      title: "All Parts",
      desc: "Browse the full site inventory list",
      icon: "📦",
      accent: "linear-gradient(135deg,#0ea5e9,#22c55e)",
    },
    {
      key: "receive",
      title: "Receive Parts",
      desc: "Add stock into inventory",
      icon: "⬇️",
      accent: "linear-gradient(135deg,#16a34a,#22c55e)",
    },
    {
      key: "issue",
      title: "Issue Parts",
      desc: "Remove stock from inventory",
      icon: "⬆️",
      accent: "linear-gradient(135deg,#f97316,#ef4444)",
    },
    {
      key: "workorders",
      title: "Work Orders",
      desc: "Create and manage work orders",
      icon: "🧾",
      accent: "linear-gradient(135deg,#111827,#4b5563)",
    },
    {
      key: "assetinspection",
      title: "Asset Inspection",
      desc: "Log inspections + view due summaries",
      icon: "🛠️",
      accent: "linear-gradient(135deg,#f59e0b,#ef4444)",
    },
    {
      key: "printersettings",
      title: "Printer Settings",
      desc: "Label sizes + layout profiles",
      icon: "🖨️",
      accent: "linear-gradient(135deg,#0ea5e9,#2563eb)",
    },

  ];

  const cardWrap = { maxWidth: 980, margin: "10px auto" };

  const panel = {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
    padding: 18,
  };

  const subtle = { fontSize: 12, color: "#6b7280", fontWeight: 700 };

  const actionBtn = {
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "white",
    cursor: "pointer",
    fontWeight: 800,
  };

  return (
    <div style={cardWrap}>
      <div style={panel}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", gap: 14, alignItems: "flex-start", flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 900 }}>Dashboard</div>
            <div style={{ fontSize: 13, color: "#6b7280", fontWeight: 600 }}>
              Select a tool to continue.
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {onChangeSite && (
              <button onClick={onChangeSite} style={actionBtn} type="button">
                ⬅ Change Site
              </button>
            )}
          </div>
        </div>

        {/* Tiles */}
        <div style={{ marginTop: 16 }}>
          <div style={{ ...subtle, marginBottom: 10 }}>TOOLS</div>

          <div
            style={{
              display: "grid",
              gap: 12,
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            }}
          >
            {items.map((it) => (
              <button
                key={it.key}
                onClick={() => onNav(it.key)}
                type="button"
                style={{
                  textAlign: "left",
                  padding: 14,
                  borderRadius: 16,
                  border: "1px solid #e5e7eb",
                  background: "white",
                  cursor: "pointer",
                  transition: "transform 0.08s ease, box-shadow 0.08s ease",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.05)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 10px 22px rgba(0,0,0,0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.05)";
                }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 14,
                      background: it.accent,
                      display: "grid",
                      placeItems: "center",
                      color: "white",
                      fontSize: 18,
                      boxShadow: "0 10px 18px rgba(0,0,0,0.10)",
                      flex: "0 0 auto",
                    }}
                  >
                    {it.icon}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 900, fontSize: 15, color: "#111827" }}>
                      {it.title}
                    </div>
                    <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 600, marginTop: 2 }}>
                      {it.desc}
                    </div>
                  </div>

                  <div style={{ color: "#9ca3af", fontWeight: 900 }}>→</div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Footer hint */}
        <div style={{ marginTop: 14, fontSize: 12, color: "#6b7280", fontWeight: 600 }}>
          Tip: Use <b>Scan QR</b> inside Search / Lookup for faster workflows.
        </div>
      </div>
    </div>
  );
}
